import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Properties, PropertiesResponse } from './types'

export const propertiesListMounted = createEvent()

export const getProperties = fx<void, PropertiesResponse>({
  method: 'GET',
  url: `/nova/property`,
})

export const $properties = restore<Properties[]>(
  getProperties.doneData.map((a) => a.body.items),
  [],
)

sample({
  clock: propertiesListMounted,
  fn: () => {
    const orderBy = 'id'

    let query = {}

    // @ts-ignore
    query['order'] = orderBy

    return {
      query,
    }
  },
  target: getProperties,
})
